import { render } from "./tree.vue?vue&type=template&id=610b47e2&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"

import "./tree.vue?vue&type=style&index=0&id=610b47e2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610b47e2"],['__file',"src/components/tree/tree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "610b47e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('610b47e2', __exports__)) {
    api.reload('610b47e2', __exports__)
  }
  
  module.hot.accept("./tree.vue?vue&type=template&id=610b47e2&scoped=true", () => {
    api.rerender('610b47e2', render)
  })

}


export default __exports__